/*
* @author: liuxu7
* @date: 2018-03-14
* @description: 气泡组件
* @type: custom/default
* @position ['top', 'top-start', 'top-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end', 'right', 'right-start', 'right-end']
* */
import template from './index.html'
import ko from 'knockout'
import Base from '@/core/base'
import Common from './common'
class Poptip extends Base {
  initialize (params) {
    this.title = params.title || ''
    this.question = params.question || false
    this.trigger = params.trigger || 'hover'
    Common.initialize.call(this, params)
  }
  methods () {
    this.handleClick = () => {}
    this.handleHover = () => {}
    function handleVisible () {
      this.visible(Number(!this.visible()))
    }
    if (this.trigger === 'click') {
      this.handleClick = handleVisible
    } else {
      this.handleHover = handleVisible
    }
  }
  computed () {
    this.hasMarkup = ko.computed(() => {
      if (this.$templateNodes.length > 0) {
        let nodeList = this.$templateNodes.filter((node) => {
          return node.nodeName !== '#text' && node.nodeName !== '#comment'
        })
        return nodeList.length > 0
      } else {
        return false
      }
    })
  }
  subscribe (params) {
    Common.subscribe.call(this, params)
  }
}
export default {
  name: 'poptip',
  init: Base.createViewModel(Poptip),
  template
}



// WEBPACK FOOTER //
// ./src/components/poptip/index.js